import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Button,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Trash } from "@phosphor-icons/react";
import React, { useState } from "react";
import useTrigger from "../../globalState/useTrigger";
import cr from "../../lib/request";
import { AdminUser } from "../../const/types";

type Props = {
  data: AdminUser;
};

export default function DeleteAdminAccountModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onDelete = () => {
    setLoading(true);
    const url = `api/account/${data.id}/destroy`;
    cr.delete(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Gagal menghapus akun",
          description: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <IconButton
        aria-label="deleteButton"
        icon={<Icon as={Trash} fontSize={20} />}
        variant={"ghost"}
        colorScheme="red"
        className="clicky"
        onClick={onOpen}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Hapus Akun Admin</ModalHeader>
          <ModalBody>
            <Text mb={4}>
              Apakah Anda yakin akan menghapus akun <b>{data.name}</b>
            </Text>
            <Alert colorScheme="red" borderRadius={8} variant={"left-accent"}>
              <Box>
                <AlertTitle fontSize={20} mb={2} color={"red.500"}>
                  PERHATIAN!
                </AlertTitle>
                <AlertDescription>
                  Akun akan dihapus secara permanen dan aksi ini{" "}
                  <b>tidak bisa dibatalkan</b>
                </AlertDescription>
              </Box>
            </Alert>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button className="btn clicky" onClick={onClose}>
              Batal
            </Button>

            <Button
              type="submit"
              form={"deleteBlogKategoriForm"}
              onClick={onDelete}
              isLoading={loading}
              className="clicky"
              colorScheme="red"
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
